import { render } from "./BtnScrollDown.vue?vue&type=template&id=d6a3dee8&scoped=true"
import script from "./BtnScrollDown.vue?vue&type=script&lang=js"
export * from "./BtnScrollDown.vue?vue&type=script&lang=js"

import "./BtnScrollDown.vue?vue&type=style&index=0&id=d6a3dee8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6a3dee8"]])

export default __exports__